<template>
  <div class="wrapper">
    <el-row :gutter="80" :style="screenWidth>768?'':'padding-left: 50px;padding-right: 50px;'">
      <el-col v-for="(n,idx) in worksList" :key="idx" :span="screenWidth<=768?24:12">
        <div :style="screenWidth>768?offsetBottom(idx):''" class="work-placeholder-item pr lf-0">
          <div :index="idx" :class="screenWidth>1200?'transition-wrap':''"
          class="graylight-bg pr ht-100x">
            <div
              style="height:50%;"
              class="wi-100x centerimage transition-slow pa bm-0 lf-0"></div>
          </div>
          <div class="dis-ib pa lf--30 works-items-title-box">
            <div :style="screenWidth>768?'':'width:'+screenWidth*0.6+'px;'" class="work-placeholder-title serif cur-p" style="background: #E9E9E9;"></div>
            <div :style="screenWidth>768?'':'width:'+screenWidth*0.4+'px;'"  class="work-placeholder-tags" style="background: #E9E9E9;"></div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'workPlaceholder',
  computed: {
    ...mapGetters([
      'scrollHeight',
      'screenWidth'
    ])
  },
  watch: {
    scrollHeight (val) {
      this.offsetBottom()
    }
  },
  methods: {

    /**
    * 滚动偏移计算
    */
    offsetBottom (idx) {
      let res = ''
      if (idx % 2 === 1) {
        res = 'bottom: ' + (this.scrollHeight * 7 - 100) + 'px'
      } else {
        res = 'bottom: ' + this.scrollHeight * 2 + 'px'
      }
      return res
    }
  },
  data () {
    return {
      worksList: [{}, {}, {}, {}, {}, {}]
    }
  }
}
</script>
<style>
.work-placeholder-more {
  font-size: 1.625em;
  font-weight: 600;
}
.work-placeholder-title {
  font-size: 1.8em;
  font-weight: 600;
  margin-bottom: 6px;
  /* 宽*0.6 */
  width: 240px;
  height: 35px;
}
.work-placeholder-item {
  height: 27em;
  margin-bottom: 4em;
}
.work-placeholder-tags {
  font-size: 0.875em;
  /* 宽*0.4 */
  width: 160px;
  height: 20px;
  margin-top: 10px;
}
.works-items-title-box {
  bottom: 1.5em;
}
@media screen and (min-width: 768px) and (max-width: 992px) {
  .work-placeholder-title {
    font-size: 28px;
    font-weight: 600;
    margin-bottom: 6px;
    width: 250px;
    height: 40px;
  }
  .work-placeholder-item {
    height: 400px;
    margin-bottom: 90px;
  }
  .work-placeholder-tags {
    font-size: 15px;
    width: 200px;
    height: 20px;
    margin-top: 10px;
  }
  .works-items-title-box {
    bottom: 28px;
  }
  .work-placeholder-more {
    font-size: 28px;
    font-weight: 600;
  }
}
@media screen and (min-width: 992px) and (max-width: 1200px) {
  .work-placeholder-title {
    font-size: 32px;
    font-weight: 600;
    margin-bottom: 6px;
    width: 350px;
    height: 45px;
  }
  .work-placeholder-item {
    height: 500px;
    margin-bottom: 100px;
  }
  .work-placeholder-tags {
    font-size: 15px;
    width: 250px;
    height: 25px;
    margin-top: 10px;
  }
  .works-items-title-box {
    bottom: 40px;
  }
  .work-placeholder-more {
    font-size: 32px;
    font-weight: 600;
  }
}
@media screen and (min-width: 1200px) and (max-width: 1920px) {
  .work-placeholder-title {
    font-size: 38px;
    font-weight: 600;
    margin-bottom: 6px;
    width: 400px;
    height: 50px;
  }
  .work-placeholder-item {
    height: 600px;
    margin-bottom: 110px;
  }
  .work-placeholder-tags {
    font-size: 16px;
    width: 300px;
    height: 30px;
    margin-top: 10px;
  }
  .works-items-title-box {
    bottom: 50px;
  }
  .work-placeholder-more {
    font-size: 38px;
    font-weight: 600;
  }
}
@media screen and (min-width: 1920px) {
  .work-placeholder-title {
    font-size: 46px;
    font-weight: 600;
    margin-bottom: 6px;
    width: 500px;
    height: 60px;
  }
  .work-placeholder-item {
    height: 700px;
    margin-bottom: 120px;
  }
  .work-placeholder-tags {
    font-size: 16px;
    width: 300px;
    height: 40px;
    margin-top: 15px;
  }
  .works-items-title-box {
    bottom: 60px;
  }
  .work-placeholder-more {
    font-size: 46px;
    font-weight: 600;
  }
}
</style>



// WEBPACK FOOTER //
// src/compos/workPlaceholder.vue